import { type Page, type Router, routerCreate } from '@subaio/utils'

export const createRouter = (routes: Record<string, string>, getPage: () => Page): Router => {
	const defaultRouter = routerCreate(
		Object.fromEntries(Object.entries(routes).filter(([name]) => name !== 'PersonalSignUp')),
	)
	const personalRouter = routerCreate(
		Object.fromEntries(
			Object.entries(routes)
				.filter(([name]) => name !== 'SignUp' && name !== 'McpLogin')
				.map(([name, path]) => [name, `/personal/${path.replace(/^\//u, '')}`]),
		),
	)
	const getPath: Router['getPath'] = (page, origin) => {
		if (page.name === 'McpLogin' || (page.params?.designBrand ?? getPage().params?.designBrand) !== 'personal')
			return defaultRouter.getPath(page, origin)
		return personalRouter.getPath(page.name === 'SignUp' ? { ...page, name: 'PersonalSignUp' } : page, origin)
	}

	return {
		names: [...defaultRouter.names, 'PersonalSignUp'],
		getPath,
		match: (url) => {
			const personalPage = personalRouter.match(url)
			if (personalPage) return { ...personalPage, params: { ...personalPage.params, designBrand: 'personal' } }
			const page = defaultRouter.match(url)
			if (page) return { ...page, params: { ...page.params, designBrand: '' } }
			return {
				name: 'NotFound',
				params: {
					designBrand:
						new URL(url, 'https://financedata.invalid').pathname.split('/')[1] === 'personal' ? 'personal' : '',
				},
			}
		},
		extendPage: (page) => {
			const url = getPath(page)
			if (url === null) throw new Error(`Unknown page name '${page.name}'`)
			return { ...page, params: { ...page.params, url } }
		},
	}
}

export const withDesignBrand = (previous: Page, next: Page): Page => ({
	...next,
	name:
		(next.params?.designBrand ?? previous.params?.designBrand) === 'personal' && next.name === 'SignUp'
			? 'PersonalSignUp'
			: next.name,
	params: {
		...next.params,
		designBrand: next.name === 'McpLogin' ? '' : (next.params?.designBrand ?? previous.params?.designBrand ?? ''),
	},
})
